import React from 'react'
import PriceListItem from '../PriceListItem/PriceListItem'

import * as Styled from './PriceList.styles'

type PriceListProps = {
  net: number
  gross: number
  tax: number
  taxPercentage: number
}

const PriceList: React.FunctionComponent<PriceListProps> = ({ gross, net, tax, taxPercentage }) => (
  <Styled.PriceList>
    <PriceListItem amount={gross} title="Subtotaal" />
    <PriceListItem amount={tax} title={`BTW (${taxPercentage}%)`} />
    <PriceListItem amount={net} title="Totaal" highlight />
  </Styled.PriceList>
)

export default PriceList
